'use client'

import React from 'react'

import TextConverterLayout from '../TextConverterLayout'
import convertSimplifiedToTraditional from './convertSimplifiedToTraditional'


export default function SimplifiedTraditionalConverter() {
  return (
    <TextConverterLayout
      convert={convertSimplifiedToTraditional}
      indentOptionsEnabled={false}
      downloadFileExt={'.txt'}
    />
  )
}
